var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.scroll_to)?_c('button',{staticClass:"main-button",on:{"click":function($event){return _vm.scroll()}}},[_vm._t("default")],2):(_vm.route_name)?_c('router-link',{attrs:{"to":_vm.route_name}},[_c('button',{staticClass:"main-button"},[_vm._t("default")],2)]):_c('a',{staticClass:"main-button",attrs:{"href":_vm.href}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }